// we disable eslint because the return type is dynamic, so we cannot add it explicitly
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export function createPolymorphicComponent(component) {
    return component;
}
//# sourceMappingURL=createPolymorphicComponent.js.map